module.exports = {
  email: 'sayankar1308@gmail.com',

  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/SayanKar',
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/_sayan_kar',
    },
    {
      name: 'Twitter',
      url: 'https://twitter.com/Sayan1308Kar',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/sayan-kar-',
    },
    {
      name: 'Discord',
      url: 'https://discordapp.com/users/616880360382267415',
    },
    {
      name: 'Telegram',
      url: 'https://telegram.me/S3CR37G8057',
    },
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Work',
      url: '/#projects',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  colors: {
    green: '#599bf2',
    navy: '#09090b',
    darkNavy: '#020c1b',
  },

  srConfig: (delay = 200, viewFactor = 0.25) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
